/** 与正确接口一致：http://api.qyz.com/api/v1/... */
const DEFAULT_API_BASE = 'https://api.kjlibs.com'

/**
 * 接口根地址。
 * - 默认始终为 https://api.kjlibs.com（避免 dev 用局域网 IP 打开页面时，请求误发到 :8081 导致 404）
 * - 显式设置 VUE_APP_API_BASE_URL 可覆盖（如内网调试后端）
 * - 若遇跨域且需走 devServer 代理：在 .env.development 设置 VUE_APP_DEV_PROXY=1（此时 baseURL 为空，请求 /api/...）
 */
export function getApiBase() {
  const v = process.env.VUE_APP_API_BASE_URL
  if (typeof v === 'string' && v.trim() !== '') {
    return v.trim().replace(/\/$/, '')
  }
  if (process.env.VUE_APP_DEV_PROXY === '1' && process.env.NODE_ENV === 'development') {
    return ''
  }
  return DEFAULT_API_BASE
}

/** 拼接图片等静态资源；开发时若 API 走代理，资源仍可能在后端域名上 */
export function getMediaOrigin() {
  const m = process.env.VUE_APP_MEDIA_BASE_URL
  if (typeof m === 'string' && m.trim() !== '') {
    return m.trim().replace(/\/$/, '')
  }
  const base = getApiBase()
  if (base) return base
  return DEFAULT_API_BASE
}
